import { render } from "./Bottom_Inscription_Section.vue?vue&type=template&id=8c52f6f6"
import script from "./Bottom_Inscription_Section.vue?vue&type=script&lang=js"
export * from "./Bottom_Inscription_Section.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__